/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Delete_TeamInputs */

const th_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบ`)
};

const en_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const ja_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

const es_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const pt_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir`)
};

const id_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus`)
};

const fr_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const tl_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burahin`)
};

const vi_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá`)
};

const ko_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삭제`)
};

const de_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const ru_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const tr_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sil`)
};

const it_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina`)
};

const pl_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const uk_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити`)
};

const hi_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const ar_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const ms_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padam`)
};

const bn_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মুছুন`)
};

const zh_tw2_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刪除`)
};

const zh_hk2_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刪除`)
};

const ur_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف کریں`)
};

const fa_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const sw_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Futa`)
};

const nl_admin_delete_team = /** @type {(inputs: Admin_Delete_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Admin_Delete_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_delete_team = /** @type {((inputs?: Admin_Delete_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Delete_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_delete_team(inputs)
	if (locale === "ja") return ja_admin_delete_team(inputs)
	if (locale === "zh") return zh_admin_delete_team(inputs)
	if (locale === "es") return es_admin_delete_team(inputs)
	if (locale === "pt") return pt_admin_delete_team(inputs)
	if (locale === "id") return id_admin_delete_team(inputs)
	if (locale === "fr") return fr_admin_delete_team(inputs)
	if (locale === "tl") return tl_admin_delete_team(inputs)
	if (locale === "vi") return vi_admin_delete_team(inputs)
	if (locale === "ko") return ko_admin_delete_team(inputs)
	if (locale === "de") return de_admin_delete_team(inputs)
	if (locale === "ru") return ru_admin_delete_team(inputs)
	if (locale === "tr") return tr_admin_delete_team(inputs)
	if (locale === "it") return it_admin_delete_team(inputs)
	if (locale === "pl") return pl_admin_delete_team(inputs)
	if (locale === "uk") return uk_admin_delete_team(inputs)
	if (locale === "hi") return hi_admin_delete_team(inputs)
	if (locale === "ar") return ar_admin_delete_team(inputs)
	if (locale === "ms") return ms_admin_delete_team(inputs)
	if (locale === "bn") return bn_admin_delete_team(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_delete_team(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_delete_team(inputs)
	if (locale === "ur") return ur_admin_delete_team(inputs)
	if (locale === "fa") return fa_admin_delete_team(inputs)
	if (locale === "sw") return sw_admin_delete_team(inputs)
	if (locale === "nl") return nl_admin_delete_team(inputs)
	return en_admin_delete_team(inputs)
});